
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as deckhUhpJa3ETz7XSHFW4z1v2XAasjCEhOKqKUu8HOGB5OMMeta } from "/opt/buildhome/repo/src/pages/deck.vue?macro=true";
import { default as indexL6IBblXwOeGe20PFY6CEA_XHd4mNKrrU5AlHwcK4aA4Meta } from "/opt/buildhome/repo/src/pages/index.vue?macro=true";
import { default as scheduleL1J0bHOc5Ovneufs923lPB_45OWxnIp9Up5T4Yu19UJ8oMeta } from "/opt/buildhome/repo/src/pages/schedule.vue?macro=true";
export default [
  {
    name: "deck",
    path: "/deck",
    component: () => import("/opt/buildhome/repo/src/pages/deck.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/src/pages/index.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/opt/buildhome/repo/src/pages/schedule.vue")
  }
]